/**
 * Rounds value
 * @param {number} num - Value for rounding
 * @param {number} digits - Count of digits after comma
 *
 * @returns {float} - Rounded value
 */

function roundToOne (num, digits = 1) {
  return +(Math.round(num + ('e+' + digits)) + 'e-' + digits)
}

export default roundToOne
